import { Link } from "react-router-dom";
import { appPath } from "@/constants/paths";
import { FileQuestion } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
      <FileQuestion className="mb-4 size-16 text-muted-foreground/40" />
      <h1 className="mb-2 text-6xl font-bold tracking-tight text-foreground">
        404
      </h1>
      <p className="mb-8 text-xl text-muted-foreground">
        الصفحة المطلوبة غير موجودة
      </p>
      <Button asChild>
        <Link to={appPath()}>العودة إلى لوحة التحكم</Link>
      </Button>
    </div>
  );
}
